import React, { useState, useEffect } from "react";
import { useStyles } from "./TrailingPeriodScreenStyles.css";
import CountdownBar from "./CountdownBar";
import { FormattedMessage, useIntl } from "react-intl";

const TrailingPeriodScreen = ({ duration, handleEndOvertime }) => {
    const [time, setTime] = useState(duration);
    const classes = useStyles();
    const intl = useIntl();

    useEffect(() => {
        console.log(time);
        time > 0 && setTimeout(() => setTime(time - 1), 1000);
        if (time === 0) {
            handleEndOvertime();
        }
    }, [time]);

    return (
        <div className={classes.trailingPeriodContainer}>
            <div className={classes.trailingPeriodInfoBox}>
                <div className={classes.trailingPeriodInfoText}>
                    <FormattedMessage
                        id={"app.game.session.overtime.infoText"}
                        defaultMessage={"Please make any additional decisions"}
                    />
                </div>
                <div className={classes.trailingPeriodInfoText}>Time left:</div>
                <div className={classes.trailingPeriodCountdown}>{time}</div>
                <CountdownBar
                    dimensions={100 - (100 / duration) * (duration - time)}
                ></CountdownBar>
            </div>
        </div>
    );
};

export default TrailingPeriodScreen;
